<template>
    <main-layout>

        <!-- Wrapper avec dégradé bleu (comme Vite) -->
        <div class="bg-gradient-to-b from-secondary to-primary">
            <app-header icon="user" class="text-white pt-4 px-4">
                <h1 class="text-2xl flex items-center gap-3">
                    <span>Mon profil</span>
                </h1>
            </app-header>
            <!-- Action bar (Retour + action état) -->
            <action-bar :back="{ name: 'home' }" class="px-4 pb-6">
                <!-- Bouton déconnexion (garde l’ID + @click existants) -->
                <button id="main-action"
                    class="bg-white transition px-4 py-2 rounded-lg text-alert text-sm font-medium uppercase"
                    @click="logout">
                    Déconnexion
                </button>
            </action-bar>

            <!-- Section profil (avatar + nom + rôle + ID) -->
            <section class="relative px-8 pb-15">
                <div class="flex flex-col md:flex-row items-center md:justify-between">
                    <!-- Avatar : mobile d’abord, à droite sur md -->
                    <div class="order-1 md:order-2 mb-4 md:mb-0">
                        <div class="w-16 h-16 md:w-20 md:h-20 rounded-full bg-center bg-cover mx-auto border-2 border-white/60 shadow"
                            :style="{ backgroundImage: `url(${photoProfil})` }" id="profil_client_avatar" />
                    </div>

                    <!-- Texte : nom + rôle -->
                    <div class="order-2 md:order-1">
                        <h2 id="profil_client_name"
                            class="font-bold text-gris-bleu mb-2 text-3xl text-center md:text-left">
                            {{ user.first_name }} <strong class="font-extrabold">{{ user.last_name }}</strong>
                        </h2>
                        <p id="profil_client_role" class="text-md md:text-xl text-white mb-2 text-center md:text-left">
                            Technicien
                        </p>
                    </div>
                </div>

                <!-- Bloc ID -->
                <div class="w-[70%] mx-auto md:mx-0 text-center md:text-left mb-12">
                    <div
                        class="inline-flex items-center gap-2 px-2 py-1 rounded-xl bg-secondary text-white text-md font-medium">
                        <span class="font-normal">ID</span>
                        <span class="font-bold" id="profil_client_id">{{ paddedOperatorId }} {{ user.id }}</span>
                    </div>
                </div>
            </section>
        </div>

        <!-- Contenu principal : fond dégradé + arrondi (comme Vite) -->
        <main class="bg-gradient-to-b from-[#F8FBFF] to-[#E2E9F5] rounded-t-3xl -mt-6 flex-1 overflow-y-auto shadow-xl">
            <div class="p-4">

                <!-- Ligne infos (email / phone / immat / signature) -->
                <div class="space-y-3">
                    <p class="flex items-center text-md md:text-xl">
                        <i class="inline-block h-6 w-6 mask mask-arobase bg-secondary mr-3"></i>
                        <span id="profil_client_email">{{ user.username }}</span>
                    </p>
                    <p class="flex items-center text-md md:text-xl">
                        <i class="inline-block h-6 w-6 mask mask-phone bg-secondary mr-3"></i>
                        <span id="profil_client_phone">{{ user.phone }}</span>
                    </p>
                    <p class="flex items-center text-md md:text-xl" v-show="user.type !== 'magasinier'"
                        id="display_immat_info">
                        <i class="inline-block h-6 w-6 mask mask-car bg-secondary mr-3"></i>
                        <span id="profil_client_matricule">{{ user.immatriculation }}</span>
                    </p>
                    <p class="flex items-center text-md md:text-xl">
                        <i class="inline-block h-6 w-6 mask mask-sign bg-secondary mr-3"></i>
                        <img :src="user.signature64 || ''" alt="Signature" class="h-12" id="profil_client_signature">
                    </p>

                    <!-- CTA “Modifier mon profil” -->
                    <div class="text-center">
                        <a id="edit-profil" href="javascript:void(0);" @click="showFormUser = true"
                            class="inline-flex items-center px-4 py-2 bg-primary text-white font-semibold rounded-lg shadow text-md">
                            <i class="inline-block h-6 w-6 mask mask-edit bg-white mr-2"></i>
                            <span>Modifier mon profil</span>
                        </a>
                    </div>

                    <!-- Modale édition infos (version Tailwind) -->
                    <div v-show="showFormUser"
                        class="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50">

                        <div
                            class="relative space-y-4 max-w-[350px] w-[90%] mx-auto bg-white rounded-lg p-6 text-center shadow-xl">

                            <!-- Bouton croix -->
                            <button @click="showFormUser = false"
                                class="absolute top-3 right-3 bg-alert transition w-6 h-6 rounded-full flex items-center justify-center">
                                <i class="inline-block h-5 w-5 mask mask-close bg-white"></i>
                            </button>
                            <h2 class="text-lg font-medium mb-5 uppercase text-secondary">Modifier mes informations</h2>

                            <div class="flex gap-2 justify-center">
                                <a id="photo-trigger" href="javascript:void(0);" @click="triggerPhoto"
                                    class="btn-secondary">
                                    Photo
                                </a>
                                <a href="javascript:void(0);" @click="showModal = true" class="btn-vert">
                                    Signature
                                </a>
                            </div>

                            <div class="text-left">
                                <label for="profil_client_phone_form"
                                    class="block text-sm font-medium mb-1">Téléphone</label>
                                <cleave :options="telOpt" ref="telephone" type="text" name="numtel"
                                    placeholder="Téléphone" class="w-full input px-3 py-2 border rounded-md"
                                    id="profil_client_phone_form" v-model="user.phone" inputmode="tel" />
                            </div>

                            <div id="display_immat" v-show="user.type !== 'magasinier'" class="text-left">
                                <label id="profil_client_matricule_label" for="profil_client_matricule_form"
                                    class="block text-sm font-medium mb-1">
                                    Immatriculation
                                </label>
                                <input type="text" name="immat" placeholder="Immatriculation véhicule" maxlength="20"
                                    id="profil_client_matricule_form" class="w-full input px-3 py-2 border rounded-md"
                                    v-model="user.immatriculation">
                            </div>

                            <p class="warning-info text-alert uppercase"></p>

                            <a id="profil_client_submit_form" href="javascript:void(0);" @click="saveInfos"
                                class="btn-primary inline-block px-4 py-2 rounded-md bg-primary text-white">
                                SAUVEGARDER
                            </a>
                        </div>
                    </div>


                    <!-- Attestation -->
                    <div class="text-center" v-if="user.type !== 'magasinier' && user.attestation_aptitude" id="display_attestation">
                        <hr class="border-gray-300 mx-auto">
                        <p class="text-md md:text-xl mt-4">Attestation d'aptitude</p>
                        <div class="flex items-center justify-center gap-2 mb-4">
                            <i class="inline-block h-6 w-6 mask mask-security bg-secondary"></i>
                            <span class="text-md md:text-xl font-bold text-secondary" id="profil_client_attestation">
                                {{ user.attestation_aptitude }}
                            </span>
                        </div>
                    </div>
                </div>

                <!-- Boutons d’action -->
                <div class="mt-6 flex flex-col items-center space-y-6 mb-40">
                    <button id="profil_client_send_data"
                        class="inline-flex items-center px-4 py-2 bg-success text-white font-semibold rounded-lg shadow text-md"
                        @click.prevent="askSendData">
                        <i class="inline-block h-6 w-6 mask mask-support bg-white mr-2"></i>
                        Envoyer mes données au support
                    </button>

                    <a id="profil_client_help" href="javascript:void(0);"
                        class="inline-flex items-center px-4 py-2 bg-white text-orange font-semibold rounded-lg shadow text-md"
                        @click.prevent="$emit('help')">
                        <i class="inline-block h-6 w-6 mask mask-question bg-orange mr-2"></i>
                        Aide &amp; tutoriels
                    </a>

                    <a class="items-center px-4 py-2 bg-white text-alert font-semibold rounded-lg shadow text-md"
                        href="javascript: void 0" v-if="this.user.operator && this.user.operator.id === 5"
                        @click.prevent="askDeleteDonnee">
                        DEBUG : Supprimer les données
                    </a>


                    <button id="profil_client_delete"
                        class="items-center px-4 py-2 bg-white text-alert font-semibold rounded-lg shadow text-md"
                        @click.prevent="askDeleteData" v-if="isDemo === true">
                        <i class="inline-block h-6 w-6 mask mask-trash bg-alert mr-2"></i>
                        Supprimer mes données
                    </button>

                </div>

            </div>
        </main>

        <!-- Signature modal (inchangé) -->
        <signature-modal v-show="showModal" @close="showModal = false" :signature="user.signature64"
            @signatureUpdated="updateSignature" />

        <!-- Inputs cachés / Upload (inchangé) -->
        <form method="post" class="change-pdp hidden">
            <input type="hidden" name="change-photo-profil">
        </form>
        <input ref="photoInput" @change="updatePhoto" type="file" accept="image/*" id="photo-profil" class="hidden" />
        <ul id="prev-photo-profil" class="hidden"></ul>

    </main-layout>
</template>


<style scoped>
.fixed-bottom-btn {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #f1f1f1;
    padding: 15px;
    color: #ff0000;
    font-size: 13px;
}
</style>

<script>

import SignatureModal from '../common/SignatureModal.vue'

import Security from '../../js/core/Security.js'
import User from '../../js/models/User'
import Api from '../../js/core/Api'

import Cleave from 'vue-cleave'

require('cleave.js/dist/addons/cleave-phone.fr');

import loadImage from 'blueimp-load-image'

export default {
    data() {
        return {
            user: {},
            showModal: false,
            isDemo: false,
            showFormUser: false,
            telOpt: {
                phone: true,
                phoneRegionCode: 'fr'
            }
        }
    },
    mounted: function () {
        this.fetchUserData()
    },
    computed: {
        photoProfil() {
            if (this.user.photo64 && this.user.photo64 !== '') {
                return this.user.photo64
            } else {
                return require('@/img/user-default.png')
            }
        },
        paddedOperatorId() {
            const id =
                this.user && this.user.operator && this.user.operator.id != null
                    ? String(this.user.operator.id)
                    : "";
            // si c'est un nombre, on le convertit en string et on pad à 4
            return id.padStart(4, "0");
        },
    },
    methods: {
        async askSendData() {
            let data = await this.getData();
            let json = data && data.text ? JSON.parse(data.text) : null;
            let isSync = !!(json.offlineActions && json.offlineActions.length);
            let api = await Api.init();

            swal({
                'title': 'Envoi des données au support',
                'text': "Assurez vous d'avoir une bonne connexion à internet",
                'type': 'warning',
                'confirmButtonText': 'Envoyer',
                'showLoaderOnConfirm': true,
                'preConfirm': () => {

                    return new Promise((resolve, reject) => {
                        if (false === isSync) {
                            resolve(true);
                            return;
                        }

                        api
                            .post('/mail/report', data)
                            .then(res => {
                                if (res.status === 200) {
                                    resolve(res)
                                } else {
                                    reject(res)
                                }
                            })
                            .catch(err => reject(err))
                    })
                }
            }).then(() => {
                swal('Données envoyées', "Vos données ont bien été envoyées au support", 'success').then(() => {
                    localforage.setItem('offlineActions', JSON.stringify([])).then(() => this.$router.push('init'));
                });
            }).catch(() => {
                swal('Erreur', "Une erreur s'est produite lors de l'envoi des données", 'error');
            })

        },

        async askDeleteData() {
            let api = await Api.init();
            let obj = {};

            let profil = await localforage.getItem('profil');

            if (profil) {
                obj['email'] = localStorage.getItem('email');
                obj['user'] = JSON.parse(profil);
            }

            let data = {
                text: "L'utilisateur demande la suppression de ses données personnelles " + JSON.stringify(obj)
            };

            swal({
                title: 'Suppression des données personnelles',
                text: "Voulez-vous vraiment faire une demande de suppression de vos données personnelles ?",
                type: 'warning',
                confirmButtonText: 'Demander la suppression',
                cancelButtonText: 'Annuler',
                showCancelButton: true,
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    return new Promise((resolve, reject) => {

                        api.post('/mail/report', data)
                            .then(res => {
                                if (res.status === 200) {
                                    resolve(res);
                                } else {
                                    reject(res);
                                }
                            })
                            .catch(err => reject(err));
                    });
                }
            })
                .then(() => {
                    swal('Demande envoyée', "Votre demande a bien été envoyée. La suppression de vos données sera effectuée dans les plus brefs délais.", 'success')
                        .then(() => {
                            localforage.clear().then(() => this.$router.push('init'));
                        });
                })
                .catch(() => {
                    swal('Erreur', "Demande non envoyée. Veuillez contacter le support.", 'warning');
                });
        },

        async askDeleteDonnee() {

            swal({
                'title': 'DEBUG',
                'text': "Suppression des données locale",
                'type': 'warning',
                'confirmButtonText': 'Ok',
                'showLoaderOnConfirm': true
            }).then(() => {
                swal('Données envoyées', "Vos données ont bien été supprimées", 'success').then(() => {
                    localforage.setItem('offlineActions', JSON.stringify([])).then(() => this.$router.push('init'));
                });
            }).catch(() => {
                swal('Erreur', "Une erreur s'est produite", 'error');
            })

        },

        async getData() {

            let obj = {};
            let keys = await localforage.keys();

            const unauthorized = [
                'api-token',
                'lastConnexion',
                'profil',
                'OTAGS',
                'listTypesOutil',
                'listTypesOperation',
                'listFournisseurs',
                'listNomBout',
                'listFluides',
                'listEvents',
                'listHistory'
            ];

            for (let key of keys) {
                if (unauthorized.indexOf(key) === -1) {
                    let res = await localforage.getItem(key);
                    obj[key] = JSON.parse(res);
                }
            }

            if (localStorage.getItem('pwd')) {
                obj['pwd'] = localStorage.getItem('pwd');
            }

            if (localStorage.getItem('email')) {
                obj['email'] = localStorage.getItem('email');
            }


            return { text: JSON.stringify(obj) };

        },
        logout() {

            let router = this.$router;
            let security = new Security;

            security.logout(function (res) {
                if (res === 'ok') {
                    router.push('login')
                }
            })

        },
        fetchUserData() {
            User.getUserData(data => {
                this.user = data;
                this.isDemo = data.operator.demo;
                if (data.phone) {
                    this.$refs.telephone.cleave.element.value = data.phone
                }
            })
        },
        triggerPhoto() {
            this.$refs.photoInput.click()
        },
        updatePhoto(e) {
            let vueInstance = this;
            let usr = new User;
            loadImage(
                e.target.files[0],
                function (img) {

                    let photo = img.toDataURL();
                    vueInstance.user.photo64 = photo;
                    vueInstance.photoProfil = photo;
                    usr.updateUser(vueInstance.user)

                },
                {
                    maxWidth: 600,
                    maxHeight: 600,
                    orientation: true,
                    canvas: true
                } // Options
            );
        },
        updateSignature(data) {
            this.user.signature64 = data;
            let usr = new User;
            let vueInstance = this;
            usr.updateUser(vueInstance.user)
        },
        saveInfos() {
            let usr = new User;
            let vueInstance = this;
            usr.updateUser(vueInstance.user);
            this.showFormUser = false;
        }
    },
    components: {
        SignatureModal,
        Cleave
    },
}

</script>



// WEBPACK FOOTER //
// Profil.vue?e1eaf98a